import { Component, OnInit } from '@angular/core';
import { environment } from '@environments/environment';
import { SharedCommonModule } from '@shared/common.module';
import { EduLoaderComponent } from '@atoms/loader/loader.component';

@Component({
  templateUrl: './public.layout.html',
  styles: [],
  imports: [SharedCommonModule, EduLoaderComponent],
})
export class PublicComponent implements OnInit {
  ngOnInit(): void {
    // redirect to login of dashboard
    window.location.href = environment.legacyDashboardUrl + '/login?redirect=/v2';
  }
}
